module.exports = __webpack_public_path__ + "img/horn1.c815a1ae.png";